import None from './None.js';
import Some from './Some.js';
export default function tryCatch(fn) {
    try {
        return Some(fn());
    }
    catch (error) {
        return None;
    }
}
//# sourceMappingURL=tryCatch.js.map